import {
  EvaluationContextFieldOverrideFragment,
  EvaluationContextFieldOverridesQuery,
  useEvaluationContextFieldOverridesQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

export const useEvaluationContextFieldOverrides = withStandardListHook<
  EvaluationContextFieldOverridesQuery,
  EvaluationContextFieldOverrideFragment,
  'evaluationContextFieldOverrides'
>(useEvaluationContextFieldOverridesQuery, 'evaluationContextFieldOverrides');
